import {useTranslation} from 'react-i18next';

import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import {Box, Grid, IconButton, TextField, useTheme} from '@mui/material';

import {EmpionButton} from '../../../../../components/EmpionButton/EmpionButton';
import {getFieldStyle} from '../../../../../layouts/theme/FieldStyles';
import type {WorkforceProfileExtractedLanguage} from '../../types/workforceProfileDetailsTypes';

export interface Props {
  rows: WorkforceProfileExtractedLanguage[];
  onChange: (rows: WorkforceProfileExtractedLanguage[]) => void;
}

export const WorkforceProfileWizardLanguagesEditor = ({rows, onChange}: Props) => {
  const theme = useTheme();
  const {t} = useTranslation('translation', {keyPrefix: 'workforceProfilesPage.wizard.languagesEditor'});

  const updateRow = (index: number, patch: Partial<WorkforceProfileExtractedLanguage>) => {
    onChange(rows.map((row, rowIndex) => (rowIndex === index ? {...row, ...patch} : row)));
  };

  const addRow = () => {
    onChange([...rows, {language: '', level: '', evidence: ''}]);
  };

  const removeRow = (index: number) => {
    onChange(rows.filter((_, rowIndex) => rowIndex !== index));
  };

  return (
    <Box>
      {rows.map((row, index) => (
        <Grid container spacing={1.5} key={`language-${index}`} sx={{mb: 1.5}} alignItems='flex-start'>
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              size='small'
              label={t('language')}
              value={row.language}
              onChange={(event) => updateRow(index, {language: event.target.value})}
              sx={getFieldStyle(theme)}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              size='small'
              label={t('level')}
              value={row.level}
              onChange={(event) => updateRow(index, {level: event.target.value})}
              helperText={t('levelHint')}
              sx={getFieldStyle(theme)}
            />
          </Grid>
          <Grid item xs={12} sm={5}>
            <TextField
              fullWidth
              size='small'
              label={t('evidence')}
              value={row.evidence}
              onChange={(event) => updateRow(index, {evidence: event.target.value})}
              sx={getFieldStyle(theme)}
            />
          </Grid>
          <Grid item xs={12} sm={1}>
            <IconButton aria-label={String(t('remove'))} onClick={() => removeRow(index)} size='small'>
              <DeleteOutlineIcon fontSize='small' />
            </IconButton>
          </Grid>
        </Grid>
      ))}
      <EmpionButton variant='secondary' startIcon={<AddIcon />} onClick={addRow}>
        {t('add')}
      </EmpionButton>
    </Box>
  );
};
